<template>
  <label class="switcher switcher-success" v-b-tooltip.hover :title="$t(tooltip)">
    <input type="checkbox" class="switcher-input" v-model="checked" @change="change" :disabled="disabled" />
    <span class="switcher-indicator">
      <span class="switcher-yes"><span class="ion ion-md-checkmark"></span></span>
      <span class="switcher-no"><span class="ion ion-md-close"></span></span>
    </span>
    <span class="switcher-label" v-if="showLabel">{{ $i18n.t(label) }}</span>
  </label>
</template>

<script>
export default {
  props: ['label', 'tooltip', 'disabled', 'value'],
  data() {
    return {
      checked: false
    };
  },
  computed: {
    showLabel() {
      return this.label ? true : false;
    }
  },

  created() {
    this.checked = this.value;
  },

  watch: {
    checked(val) {
      this.$emit('onChange', val);
    },
    value(val) {
      this.checked = val;
    }
  },
  methods: {
    change(e) {
      this.$emit('change', e);
    }
  }
};
</script>

<style lang="scss" scoped>
.switcher-label {
  font-weight: 500;
}
</style>
